<!--
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-09-19 15:10:12
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-09-20 17:11:04
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <div class="title">
        <el-form
          ref="filterForm"
          :inline="true"
          :model="filterForm"
          class="filter-form"
        >
          <el-form-item prop="productName">
            <el-input
              class="city-select"
              v-model="filterForm.productName"
              placeholder="保险产品名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="companyName">
            <el-autocomplete
              v-model="filterForm.companyName"
              :fetch-suggestions="insureAssociate"
              placeholder="保险机构名称"
              label="companyName"
              value="companyId"
              value-key="companyName"
              :trigger-on-focus="false"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilter()">查询</el-button>
            <el-button
              type="primary"
              plain
              icon="el-icon-refresh-right"
              @click="handleReset('filterForm')"
            >
              清空
            </el-button>
          </el-form-item>
        </el-form>
        <span class="export" @click="handleToExport">导出</span>
      </div>
    </div>
    <div class="main">
      <!-- 列表 -->
      <el-table :data="tableData" style="width: 100%; margin-top: 10px">
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{
              (pagination.currentPage - 1) * pagination.pageSize +
              (scope.$index + 1)
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="保险机构名称"
          min-width="15%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="businessAddress"
          label="业务网点"
          min-width="15%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="productName"
          label="保险产品名称"
          min-width="15%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="productType"
          label="产品类型"
          min-width="15%"
          align="center"
          :formatter="formatProductType"
        >
        </el-table-column>
        <el-table-column
          prop="insureCost"
          label="保费"
          min-width="10%"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.insureCost ? `${row.insureCost}起` : '' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="insureLimit"
          label="保额"
          min-width="10%"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.insureLimit ? `${row.insureLimit}` : '' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="10%" align="center">
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              plain
              round
              size="small"
              @click="handleToDetail(row)"
              >查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-main>
</template>
<script>
import { exportFile } from '@/api/downloadRequest'
export default {
  name: 'ProductViewList',
  data() {
    return {
      filterForm: {
        companyName: '',
        productName: '',
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
    }
  },
  created() {
    this.getFinanceProductList()
  },
  methods: {
    /**
     * @description:
     * @Author: quwandong
     * @Date: 2023-10-27 08:47:21
     */
    formatProductType({ productType }) {
      return {
        1: '农机保险',
        2: '养殖保险',
        3: '种植保险',
      }[productType]
    },
    //页码切换
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getFinanceProductList()
    },
    // 获取列表数据
    async getFinanceProductList() {
      try {
        let { data } = await this.$http.insure.getInsureProductList({
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          ...this.filterForm,
        })
        this.tableData = data.content
        this.pagination.total = data.recordTotal
      } catch (error) {
        console.log(error)
      }
    },
    // 导出
    handleToExport() {
      this.$http.insure
        .insureProductExport({ ...this.filterForm })
        .then((res) => {
          exportFile(res.data, '保险机构产品查询列表', 'xlsx')
        })
    },
    // 跳详情
    handleToDetail(row) {
      console.log('row', row)
      this.$router.push({
        path: '/insure/product/view/detail',
        query: {
          id: row.id,
          businessAddress: row.businessAddress,
        },
      })
    },
    // 查询
    handleFilter() {
      this.pagination.currentPage = 1
      this.getFinanceProductList()
    },
    //重置
    handleReset(formName) {
      this.$refs[formName].resetFields()
      setTimeout(() => {
        this.handleFilter()
      }, 500)
    },
    // 保险机构
    insureAssociate(key, cb) {
      if (key !== '') {
        this.loading = true
        this.$http.insure
          .queryInsurOreByKey({ key })
          .then(({ data }) => {
            this.loading = false
            // let arr = data.map( (item,index) => ({name:item,value:index}));
            cb(data) // 渲染回调
          })
          .catch((res) => {
            this.loading = false
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';
.top-wrap {
  .title {
    display: flex;
    justify-content: space-between;
    .export {
      display: inline-block;
      width: 85px;
      height: 42px;
      text-align: center;
      line-height: 40px;
      background: #018388;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}
.city-select {
  width: 160px;
}
</style>
